import { SimulationGatewayInterface } from './core/SimulationGateway.interface'
import SimulationGateway from './gateways/SimulationGateway'

export type Dependencies = {
  simulationGateway: SimulationGatewayInterface
}

export const dependencies: Dependencies = {
  simulationGateway: new SimulationGateway(),
}
